import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useToaster } from '@components/toaster';

import { useStore } from 'models/Provider';
import {
  TasklistTemplate,
  TasklistTemplateWithMaybeIds,
  TasklistTemplateWithoutIds,
} from 'types/templates';

import { createTasklistTemplate, updateTasklistTemplate } from './requests';

export const useUpdateTasklist = (
  options?: UseMutationOptions<TasklistTemplate, AxiosError, TasklistTemplateWithMaybeIds>,
) => {
  const { showError, showSuccess } = useToaster();
  const { t } = useStore();
  const queryClient = useQueryClient();
  return useMutation(updateTasklistTemplate, {
    ...options,
    onSuccess: async (...data) => {
      showSuccess(t('company.templates.update.success'));
      await queryClient.invalidateQueries(['tasklist-templates']);
      options?.onSuccess?.(...data);
    },
    onError: () => {
      showError(t('company.templates.update.error'));
    },
  });
};

export const useCreateTasklist = (
  options?: UseMutationOptions<TasklistTemplate, AxiosError, TasklistTemplateWithoutIds>,
) => {
  const { showError, showSuccess } = useToaster();
  const { t } = useStore();
  const queryClient = useQueryClient();
  return useMutation(createTasklistTemplate, {
    ...options,
    onSuccess: async (...data) => {
      showSuccess(t('company.templates.create.success'));
      await queryClient.invalidateQueries(['tasklist-templates']);
      options?.onSuccess?.(...data);
    },
    onError: () => {
      showError(t('company.templates.create.error'));
    },
  });
};
